import type { ReactNode } from "react";
import { Stack, Typography, Grid } from "@mui/material";
import { grey } from "@mui/material/colors";
import type { ContactMetier } from "models";
import { contactsMetiersUtil } from "utils";
import {
  CommuneLink,
  PerimetreLink,
  TerritoireLink,
  MetierBox,
  PosteBox,
  CommuneAssocieeDelegueeLink,
} from "./Business";

interface ContactMetierResumeProps {
  contactMetier: ContactMetier;
}

export function ContactMetierResume({
  contactMetier,
}: Readonly<ContactMetierResumeProps>): ReactNode {
  return (
    <Grid size={12}>
      {contactsMetiersUtil.isCommune(contactMetier) && (
        <Stack direction="row" spacing={1}>
          <Typography sx={{ color: grey[500] }}>Commune :</Typography>
          <CommuneLink commune={contactMetier.commune} />
        </Stack>
      )}
      {contactsMetiersUtil.isCommuneAssocieeDeleguee(contactMetier) && (
        <Stack direction="row" spacing={1}>
          <Typography sx={{ color: grey[500] }}>Commune associée/déléguée :</Typography>
          <CommuneAssocieeDelegueeLink communeAssocieeDeleguee={contactMetier.cad} />
        </Stack>
      )}
      {contactsMetiersUtil.isPerimetre(contactMetier) && (
        <Stack direction="row" spacing={1}>
          <Typography sx={{ color: grey[500] }}>Périmètre :</Typography>
          <PerimetreLink perimetre={contactMetier.perimetre} />
        </Stack>
      )}
      {contactsMetiersUtil.isTerritoire(contactMetier) && (
        <Stack direction="row" spacing={1}>
          <Typography sx={{ color: grey[500] }}>Territoire :</Typography>
          <TerritoireLink territoire={contactMetier.territoire} />
        </Stack>
      )}
      <Stack direction="row" spacing={1}>
        <Typography sx={{ color: grey[500] }}>Métier :</Typography>
        <MetierBox metier={contactMetier.metier} />
      </Stack>
      <Stack direction="row" spacing={1}>
        <Typography sx={{ color: grey[500] }}>Poste :</Typography>
        <PosteBox poste={contactMetier.poste} />
      </Stack>
    </Grid>
  );
}
